import { z } from "zod";
import type { TestCase } from "../types";

/**
 * Builds a Zod schema for test results based on the test case's required fields.
 * screenshotUrl is always required.
 */
export function buildTestResultsSchema(
	testCase: Pick<TestCase, "requiredFields">,
) {
	const requiredFields = testCase.requiredFields;
	const shape: Record<string, z.ZodType<unknown>> = {
		referenceNumber: z.string(),
		dateOfBirth: z.string(),
		transactionStatus: z.string(),
		amount: z.string(),
		fees: z.string(),
		amountReceived: z.string(),
		transactionId: z.string(),
		notes: z.string(),
		screenshotUrl: z.string().min(1, "Please upload a screenshot"),
	};

	if (requiredFields.referenceNumber) {
		shape.referenceNumber = z.string().min(1, "Reference number is required");
	}
	if (requiredFields.dateOfBirth) {
		shape.dateOfBirth = z.string().min(1, "Date of Birth is required");
	}
	if (requiredFields.transactionStatus) {
		shape.transactionStatus = z
			.string()
			.min(1, "Please select a transaction status");
	}
	if (requiredFields.amount) {
		shape.amount = z.string().min(1, "Amount is required");
	}
	if (requiredFields.fees) {
		shape.fees = z.string().min(1, "Fees is required");
	}
	if (requiredFields.amountReceived) {
		shape.amountReceived = z.string().min(1, "Amount Received is required");
	}
	if (requiredFields.transactionId) {
		shape.transactionId = z.string().min(1, "Transaction ID is required");
	}

	return z.object(shape);
}

export type TestResultsFormData = {
	referenceNumber: string;
	dateOfBirth: string;
	transactionStatus: string;
	amount: string;
	fees: string;
	amountReceived: string;
	transactionId: string;
	screenshotUrl: string;
	notes: string;
};
